module.exports = new __parcel__URL__("people.d532b8d6.webp").toString();